import { LoadType } from '@thive/fddm-types';
import { FloorplanRevision } from '@/modules/localDevHelpers/FloorplanDesign';
import { LoadCarrierTypeV1 } from '@/modules/setupV2/components/LoadCarrierTypes/types';

export const stringToLoadTypeCategory = (value: string): LoadType['category'] =>
  (value as LoadType['category']) || 'OTHER';

export const loadCarrierTypeToLoadTypes = (
  loadCarrierTypes: LoadCarrierTypeV1[],
): FloorplanRevision['setup']['loadTypes'] =>
  loadCarrierTypes.map((lc) => ({
    id: lc.id,
    category: stringToLoadTypeCategory(lc.category),
    length: lc.length,
    width: lc.width,
    height: lc.height,
    maxHeight: lc.height ?? 0,
    weight: lc.weight,
    imgUrl: '',
  }));
